import {
  GET_CATEGORIES,
  CATEGORY_ERROR,
  GET_CATEGORY,
  DELETE_CATEGORY,
} from "../../actions/types";

const initialState = {
  categories: [],
  categoryState: null,
  loading: true,
  error: {},
};

export default function foo(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case DELETE_CATEGORY:
      return {
        ...state,
        categories: payload,
        loading: false,
      };
    case GET_CATEGORY:
      return {
        ...state,
        categoryState: payload,
        loading: false,
      };
    case GET_CATEGORIES:
      return {
        ...state,
        categories: payload,
        loading: false,
      };
    case CATEGORY_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
